import { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'

const styles: Record<string, CSSProperties> = {
  container: {
    color: '#333',
    padding: '40px 20px',
    margin: '0 auto',
    maxWidth: 480,
    fontSize: 16,
    lineHeight: 1.6,
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: 16,
    padding: '32px 24px',
    textAlign: 'center',
    width: '100%',
    maxWidth: 400,
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    border: '1px solid #e9ecef',
  },
  icon: {
    fontSize: 56,
    marginBottom: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 16,
    color: '#333',
  },
  message: {
    fontSize: 18,
    color: '#666',
    lineHeight: 1.6,
    marginBottom: 28,
  },
  notes: {
    fontSize: 14,
    color: '#999',
    lineHeight: 1.5,
    padding: '20px',
    backgroundColor: '#f8f9fa',
    borderRadius: 12,
    border: '1px solid #e9ecef',
  },
}

export default function OnboardingThankYouMessage() {
  const { t } = useTranslation('common')
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>{t('onboarding_thank_you.title')}</h2>
        <p style={styles.message}>
          {t('onboarding_thank_you.message_line1')}
          <br />
          {t('onboarding_thank_you.message_line2')}
        </p>
        <div style={styles.notes}>{t('onboarding_thank_you.note')}</div>
      </div>
    </div>
  )
}
